module.exports = __webpack_public_path__ + "static/media/PR9.6811b319.jpg";